import React from "react";
import { tableShell, getThemedTableShell } from "../../utils/tableStyles";

/**
 * Standard scrollable table container.
 * When used with `flex-1` or `fullHeight`, it expands to 100% vertical height (no fixed 450px cap),
 * allowing full-height tables to fill their container properly.
 * @param {string} [theme] — pass AppContext theme for dark/high-contrast thead
 * @param {boolean} [fullHeight] — expand to 100% vertical height
 */
const TableScrollShell = ({
  children,
  theme,
  className = "",
  innerClassName = "",
  maxHeight,
  fullHeight = false,
}) => {
  const styles = theme ? getThemedTableShell(theme) : tableShell;
  const isFull = fullHeight || className.includes("flex-1");

  return (
    <div className={`${styles.scrollOuter} ${isFull ? "flex flex-col flex-1 min-h-0 h-full" : ""} ${className}`.trim()}>
      <div
        className={`${styles.scrollInner} ${isFull ? "flex-1 min-h-0 h-full !max-h-none !rounded-none !shadow-none !border-0" : ""} ${innerClassName}`.trim()}
        style={maxHeight ? { maxHeight } : undefined}
      >
        {children}
      </div>
    </div>
  );
};

export default TableScrollShell;
export { tableShell, getThemedTableShell };
